module.exports = __webpack_public_path__ + "img/img-ceaed6.png";